import { PlatformBrandSchema } from '@kilat/shared';
import { createRepo } from './_base.js';

/**
 * platformBrands/{brandId}
 * Public read; write only by super-admin of that brand (enforced in firestore.rules).
 */
export const platformBrandsRepo = createRepo({
  path: 'platformBrands',
  schema: PlatformBrandSchema,
  name: 'platformBrands',
});
